const conditionalDisplay = (condition: boolean, a: any, b: any) => {
  return condition ? a : b;
};

export { conditionalDisplay };
